import { render, staticRenderFns } from "./AudioRecordingController.vue?vue&type=template&id=67751a67&"
import script from "./AudioRecordingController.vue?vue&type=script&lang=ts&"
export * from "./AudioRecordingController.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports